import React, { useEffect, useState } from "react";
import { Formik, Field, ErrorMessage, Form, FieldArray } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import FieldInput from "../../../../CustomComponents/FieldInput";
import ReactSelect from "react-select";
import { Button, ModalBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { getPenalty } from "../../../../../redux/categary/action";
import NumberInputBox from "../../../../CustomComponents/AllCustomeInput/NumberInputBox";
import {
  nomorethenhandread,
  removepresent,
} from "../../../../Common/FewCommonMethods";
import { titlevalidation } from "../../../../Common/commonvalidation";
import NumberInputBoxDuration from "../../../../CustomComponents/AllCustomeInput/NumberInputBoxDuration";
import AsteriskLabel from "../../../../Common/AsteriskLabel";

const ProjectAddMilestones = ({ formikxxx, setMilesModel }) => {
  const [penaltyInputMode, setPenaltyInputMode] = useState({});
  const penaltylisting = useSelector(
    ({ categary: { penaltylist } }) => penaltylist,
  );
  const dispatch = useDispatch();
  const duretiontypeoptions = [
    { value: 2, label: "Days" },
    { value: 3, label: "Weeks" },
    { value: 4, label: "Months" },
  ];

  useEffect(() => {
    dispatch(getPenalty());
  }, [dispatch]);

  // Initialize penaltyInputMode based on initialValues
  useEffect(() => {
    const initialMode = {};
    formikxxx?.values?.milestones?.forEach((milestone, index) => {
      if (milestone.penalty_id == 0) {
        initialMode[index] = true; // Show input mode if penalty_id is 0
      } else {
        initialMode[index] = false; // Show select mode otherwise
      }
    });
    setPenaltyInputMode(initialMode);
  }, []);

  const defaultMilestone = {
    title: "",
    duration: "",
    duration_type: "",
    amount: "",
    penalty_id: "",
    penalty: "",
  };

  const initialValues = {
    milestones:
      formikxxx?.values?.milestones && formikxxx.values.milestones.length > 0
        ? formikxxx.values.milestones.map((milestone) => ({
          title: milestone.title || "",
          duration: milestone.duration || "",
          duration_type: milestone.duration_type || "",
          amount: milestone.amount || "",
          penalty_id: milestone.penalty_id || "",
          penalty: milestone.penalty || "",
        }))
        : [defaultMilestone], // 👈 ADD DEFAULT MILESTONE IF EMPTY
  };


  const validationSchema = Yup.object().shape({
    milestones: Yup.array().of(
      Yup.object().shape({
        title: titlevalidation,
        duration: Yup.number()
          .required("This Field is Required")
          .test("not-zero", "Duration should not be 0", (value) => value > 0)
          .typeError("Duration must be a number"),
        duration_type: Yup.string()
          .required("Duration Type is Required")
          .test(
            "not-only-spaces",
            "Duration Type is Required",
            (value) => value.trim() !== "",
          ),
        amount: Yup.number()
          .required("This Field is Required")
          .test("not-zero", "Amount should not be 0", (value) => value > 0)
          .typeError("Amount must be a number"), // Ensures t
        penalty: Yup.string()
          .required("This Field is Required")
          .test(
            "not-only-spaces",
            "This Field is Required",
            (value) => value.trim() !== "",
          ),
      }),
    ),
  });

  const handleSubmit = (values) => {
    formikxxx?.setFieldValue("milestones", values?.milestones);
    setMilesModel(false);
  };

  const handleProficiencyChange = (selectedOption, index, setFieldValue) => {
    setFieldValue(`milestones[${index}].penalty_id`, selectedOption.value);
    setFieldValue(
      `milestones[${index}].penalty`,
      removepresent(selectedOption.label),
    );
  };

  const handlePenaltyInputChange = (event, index, setFieldValue) => {
    setFieldValue(
      `milestones[${index}].penalty`,
      removepresent(event.target.value),
    );
    setFieldValue(`milestones[${index}].penalty_id`, 0);
  };

  const handleDeadlinetypeChange = (selectedOption, index, setFieldValue) => {
    setFieldValue(`milestones[${index}].duration_type`, selectedOption.value);
  };

  const togglePenaltyMode = (index) => {
    setPenaltyInputMode((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <>
      <button onClick={() => setMilesModel(false)} className="btn close-button">
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>

      <ModalBody>
        <h4>Add / Update Milestones</h4>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {(formik) => (
            <Form>
              <FieldArray name="milestones">
                {({ push, remove }) => (
                  <div className="form-group mb-0">
                    <h6>Add Milestones (At least one milestone is required)</h6>

                    {formik.values.milestones.map((milestone, index) => (
                      <div
                        key={index}
                        className="mile-flex-cont"
                        style={{ columnGap: "10px" }}
                      >
                        <div className="w-100">
                          <div className="form-group">
                            <FieldInput
                              title={(<>{`Milestone ${index + 1} Title`} <AsteriskLabel /></>)}
                              name={`milestones.${index}.title`}
                              placeholder="Enter milestone title"
                            />
                          </div>
                          <div className="mile-flex">
                            <div className="form-group1">
                              <label><>{`Duration type`} <AsteriskLabel /></></label>
                              <ReactSelect
                                options={duretiontypeoptions}
                                placeholder="Select"
                                value={duretiontypeoptions.find(
                                  (val) =>
                                    val.value ==
                                    formik.values.milestones[index]
                                      .duration_type,
                                )}
                                onChange={(selectedOption) =>
                                  handleDeadlinetypeChange(
                                    selectedOption,
                                    index,
                                    formik.setFieldValue,
                                  )
                                }
                              />
                              <ErrorMessage
                                name={`milestones.${index}.duration_type`}
                                component="div"
                                className="error"
                              />
                            </div>
                            <div className="form-group1">
                              <NumberInputBoxDuration
                                title="Duration"
                                name={`milestones.${index}.duration`}
                                placeholder="Duration"
                              />
                            </div>
                            <div className="form-group1">
                              <NumberInputBox
                                title="Price in SAR"
                                name={`milestones.${index}.amount`}
                                placeholder="Price"
                              />
                            </div>
                            <div className="form-group1">
                              <label>
                                <>{`Penalty in %`} <AsteriskLabel /></>
                                &nbsp;
                                <img
                                  data-tooltip-id="my-tooltip-1"
                                  src={`${CloudStorage.cloudurl}/Assets/Images/common/info-circle.svg`}
                                  alt=""
                                />

                              </label>
                              {penaltyInputMode[index] ? (
                                <>
                                  <input
                                    type="text"
                                    value={
                                      formik.values.milestones[index].penalty
                                    }
                                    onChange={(event) =>
                                      handlePenaltyInputChange(
                                        event,
                                        index,
                                        formik.setFieldValue,
                                      )
                                    }
                                    placeholder="Enter penalty"
                                    onKeyDown={nomorethenhandread}
                                  />
                                  <ErrorMessage
                                    name={`milestones.${index}.penalty`}
                                    component="div"
                                    className="error"
                                  />
                                </>
                              ) : (
                                <ReactSelect
                                  options={penaltylisting?.map((penalty) => ({
                                    value: penalty.id,
                                    label: penalty.title,
                                  }))}
                                  placeholder="Select"
                                  value={
                                    Array.isArray(penaltylisting) && penaltylisting.find(
                                      (penalty) =>
                                        penalty.id == milestone.penalty_id,
                                    ) && {
                                      value: Array.isArray(penaltylisting) && penaltylisting.find(
                                        (penalty) =>
                                          penalty.id == milestone.penalty_id,
                                      ).id,
                                      label: Array.isArray(penaltylisting) && penaltylisting.find(
                                        (penalty) =>
                                          penalty.id == milestone.penalty_id,
                                      ).title,
                                    }
                                  }
                                  onChange={(selectedOption) =>
                                    handleProficiencyChange(
                                      selectedOption,
                                      index,
                                      formik.setFieldValue,
                                    )
                                  }
                                />
                              )}
                              <ErrorMessage
                                name={`milestones.${index}.penalty_id`}
                                component="div"
                                className="error"
                              />
                              <ErrorMessage
                                name={`milestones.${index}.penalty`}
                                component="div"
                                className="error"
                              />
                              <button
                                type="button"
                                onClick={() => togglePenaltyMode(index)}
                                className="buttons border-button mt-1"
                              >
                                {penaltyInputMode[index]
                                  ? "Use Select"
                                  : "Use Input"}
                              </button>
                            </div>
                          </div>
                        </div>
                        {formik.values.milestones.length > 1 && (
                          <button type="button" onClick={() => remove(index)}>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                              alt=""
                            />
                          </button>
                        )}
                      </div>
                    ))}
                    <button
                      type="button"
                      className="add-more-milestone"
                      onClick={() =>
                        push({
                          title: "",
                          duration: "",
                          duration_type: "",
                          amount: "",
                          penalty_id: "",
                          penalty: "",
                        })
                      }
                    >
                      Add more milestones
                    </button>
                  </div>
                )}
              </FieldArray>
              <div className="modal-footer mt-3">
                <button className="btn" type="submit">
                  Save
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </>
  );
};

export default ProjectAddMilestones;
